var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrowBold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: "false",
    viewBox: "0 0 18 11",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.534 1.016a1.066 1.066 0 10-1.507 1.507l7.158 7.158a1.598 1.598 0 002.26 0l7.159-7.158a1.066 1.066 0 10-1.507-1.507l-6.46 6.46a.455.455 0 01-.643 0l-6.46-6.46z",
    fillRule: "nonzero"
  })));
}
export default SvgDownArrowBold;